<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="600px"
    :before-handleClose="handleClose"
    :handleClose-on-click-modal="false"
    class="look-dialog"
  >
    <div class="look-one">
      <Content :text="text"></Content>
    </div>
  </el-dialog>
</template>
<script>
import Content from "./content.vue";

export default {
  components: { Content },
  data() {
    return {
      dialogVisible: false,
      title: "预览",
      text: "",
    };
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(text) {
      this.dialogVisible = true;
      this.text = text;
    },
  },
  updated() {
    // if (!this.dialogVisible) {
    //   return;
    // }
    // var dom = document.getElementById("look");
    // dom.style.width = "414px";
    // //img数量
    // var li = dom.getElementsByTagName("img").length;
    // //循环动态更新图片宽度
    // for (let index = 0; index < li; index++) {
    //   dom.getElementsByTagName("img")[index].style.width = "414px";
    // }
    // //p数量
    // var lp = dom.getElementsByTagName("p").length;
    // //循环动态更新段落宽度
    // for (let index = 0; index < lp; index++) {
    //   dom.getElementsByTagName("p")[index].style.width = "414px";
    // }
  },
};
</script>

<style lang="scss" scoped>
.look-dialog {
  z-index: 999999 !important;

  /deep/ .el-dialog__header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
  }
}

.look-one {
  border: 2px solid;
  color: #121327;
  border-radius: 12px;
  width: 500px;
  margin-left: 30px;
  padding: 10px;

  .look {
    position: relative;
    padding: 10px 20px;

    /deep/ img {
      width: 100%;
    }
  }
}
</style>
